import mapKeys from 'lodash/mapKeys';
import snakeCase from 'lodash/snakeCase';

import WpToastManager from 'Wpds/components/toast/WpToastManager';

// API
import * as api from '../api/updateAiReports.api';

// Utils
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

// Schemas
import UpdateAiSettingSchema from 'Shared/utils/normalizeJSON/schemas/UpdateAiSetting.schema';

// Constants
import UpdateAiSettingsConstants from 'Shared/constants/UpdateAiSettings.constants';

export const fetchUpdateAiReportsSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.FETCH_UPDATE_AI_REPORTS_SUCCESS,
  payload,
});

export const fetchUpdateAiReportSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.FETCH_UPDATE_AI_REPORT_SUCCESS,
  payload,
});

export const addCurrentlyGneratingSlugs = payload => ({
  type: UpdateAiSettingsConstants.Actions.ADD_CURRENTLY_GENERATING_SECTION_SLUGS,
  payload,
});

export const removeCurrentlyGneratingSlugs = payload => ({
  type: UpdateAiSettingsConstants.Actions.REMOVE_CURRENTLY_GENERATING_SECTION_SLUGS,
  payload,
});

export const updateUpdateAiSettingReportSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.UPDATE_UPDATE_AI_SETTING_REPORT_SUCCESS,
  payload,
});

export const deleteUpdateAiSettingReportSuccess = payload => ({
  type: UpdateAiSettingsConstants.Actions.DELETE_UPDATE_AI_SETTING_REPORT_SUCCESS,
  payload,
});

export const fetchUpdateAiReports = () => dispatch => {
  return api.fetchUpdateAiReports().then(response => {
    const normalized = normalizer(UpdateAiSettingSchema, response.data);
    dispatch(fetchUpdateAiReportsSuccess(normalized));
    return response;
  });
};

type fetchUpdateAiReportProps = {
  slug: string;
};

export const fetchUpdateAiReport = ({ slug }: fetchUpdateAiReportProps) => dispatch => {
  return api.fetchUpdateAiReport({ slug }).then(response => {
    const normalized = normalizer(UpdateAiSettingSchema, response.data);
    dispatch(fetchUpdateAiReportSuccess(normalized));
    return response;
  });
};

type createUpdateAiReportSectionsProps = {
  slug: string;
  data: { startDate: string; endDate: string; templateSectionSlugs: string[] };
  params: { generateMode?: string };
};

export const createUpdateAiReportSections = ({ slug, data, params }: createUpdateAiReportSectionsProps) => dispatch => {
  const formattedData = {
    update_ai_report: {
      start_date: data.startDate,
      end_date: data.endDate,
      template_section_slugs: data.templateSectionSlugs,
    },
    ...mapKeys(params, (value, key) => snakeCase(key)),
  };

  return api.createUpdateAiReportSections({ slug, data: formattedData }).then(response => {
    dispatch(addCurrentlyGneratingSlugs(data.templateSectionSlugs));
    return response;
  });
};

type cancelGeneratingAiReportSectionsProps = {
  slug: string;
  data: { templateSectionSlugs: string[] };
};

export const cancelGeneratingAiReportSections = ({ slug, data }: cancelGeneratingAiReportSectionsProps) => () => {
  const formattedData = {
    update_ai_report: {
      template_section_slugs: data.templateSectionSlugs,
    },
  };

  return api.cancelGeneratingAiReportSections({ slug, data: formattedData }).then(response => {
    // TODO: keeping this logic in case we need it in the future
    // dispatch(removeCurrentlyGneratingSlugs(data.templateSectionSlugs));
    return response;
  });
};

type updateUpdateAiReportProps = {
  slug: string;
  data: { publishedAt?: string; name?: string };
};

export const updateUpdateAiReport = ({ slug, data }: updateUpdateAiReportProps) => dispatch => {
  const formattedData = {
    update_ai_report: mapKeys(data, (value, key) => snakeCase(key)),
  };

  return api.updateUpdateAiReport({ slug, data: formattedData }).then(response => {
    const normalized = normalizer(UpdateAiSettingSchema, response.data);
    dispatch(updateUpdateAiSettingReportSuccess(normalized));
    return response;
  });
};

type deleteUpdateAiReportProps = {
  slug: string;
};

export const deleteUpdateAiReport = ({ slug }: deleteUpdateAiReportProps) => dispatch => {
  return api.deleteUpdateAiReport({ slug }).then(response => {
    dispatch(deleteUpdateAiSettingReportSuccess({ reportSlug: slug }));
    WpToastManager.success('Report deleted');
    return response;
  });
};
